import { useMemo, useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import FilterBar from "@/components/admin/FilterBar";
import { exportCsv } from "@/lib/csv";
import { toast } from "sonner";
import {
    EMPTY_BASIC_FILTERS,
    matchesText,
    withinDateRange,
} from "@/components/admin/adminFilters";

export default function ContactsTab({ contacts }) {
    const [filters, setFilters] = useState(EMPTY_BASIC_FILTERS);

    const filtered = useMemo(() => {
        const f = filters;
        return contacts.filter((c) => {
            if (!matchesText([c.full_name, c.email, c.phone, c.subject, c.message], f.q)) return false;
            const created = (c.created_at || "").slice(0, 10);
            if ((f.date_from || f.date_to) && !withinDateRange(created, f.date_from, f.date_to))
                return false;
            return true;
        });
    }, [contacts, filters]);

    function exportRows() {
        const headers = [
            { key: "full_name", label: "Name" },
            { key: "email", label: "Email" },
            { key: "phone", label: "Phone" },
            { key: "subject", label: "Subject" },
            { key: "message", label: "Message" },
            { key: "created_at", label: "Created at" },
        ];
        exportCsv(`contacts_${new Date().toISOString().slice(0, 10)}.csv`, headers, filtered);
        toast.success(`Exported ${filtered.length} contact(s)`);
    }

    return (
        <>
            <FilterBar
                fields={[
                    { key: "q", label: "Search", type: "text" },
                    { key: "date_from", label: "Created from", type: "date" },
                    { key: "date_to", label: "Created to", type: "date" },
                ]}
                value={filters}
                onChange={setFilters}
                onExport={exportRows}
                resultCount={filtered.length}
                totalCount={contacts.length}
            />
            <div className="card-soft mt-4 overflow-x-auto p-4">
                <Table data-testid="contacts-table">
                    <TableHeader>
                        <TableRow>
                            <TableHead>Name</TableHead>
                            <TableHead>Email</TableHead>
                            <TableHead>Subject</TableHead>
                            <TableHead>Message</TableHead>
                            <TableHead>Created</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {filtered.map((c) => (
                            <TableRow key={c.id}>
                                <TableCell className="font-medium">{c.full_name}</TableCell>
                                <TableCell>{c.email}</TableCell>
                                <TableCell>{c.subject || "—"}</TableCell>
                                <TableCell className="max-w-md truncate">{c.message}</TableCell>
                                <TableCell className="text-xs text-[#475569]">
                                    {c.created_at?.slice(0, 16)}
                                </TableCell>
                            </TableRow>
                        ))}
                        {filtered.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={5} className="py-8 text-center text-sm text-[#475569]">
                                    No contact messages match these filters.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>
        </>
    );
}
